import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { signIn, cekCookies } from "../../actions";
import LoaderModal from "../modal/LoaderModal";
import eduprimeLogo from "../../assets/branding/eduprime-logo.png";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
    };
  }

  async componentDidMount() {
    this.setState({ isFetching: true });
    await this.props.cekCookies("login");
    this.setState({ isFetching: false });
  }

  renderError({ error, touched }) {
    if (touched && error) {
      return <small>{error}</small>;
    }
  }

  renderInput = ({ input, label, meta, type, placeholder }) => {
    return (
      <div className="form-group">
        <input {...input} type={type} className="form-control" placeholder={placeholder} />
        {this.renderError(meta)}
      </div>
    );
  };

  submitLogin = async (formValues) => {
    let formData = new FormData();
    formData.append("grant_type", "password");
    formData.append("username", "admin&" + formValues.username);
    formData.append("password", formValues.password);

    this.setState({ isFetching: true });
    await this.props.signIn(formData);
    this.setState({ isFetching: false });
  };

  renderAlert = () => {
    if (this.props.fetchError) {
      if (this.props.fetchError.type === "error") {
        return <div className="text-center">{this.props.fetchError.message}</div>;
      }
    }
  };

  render() {
    const loginBg = {
      height: "100vh",
      backgroundImage: "linear-gradient(to top, rgb(9, 32, 63) 0%, rgba(255,255,255,0) 100%)",
    };
    return (
      <div className="container-fluid">
        <div className="row justify-content-md-center" style={loginBg}>
          <LoaderModal isFetching={this.state.isFetching} />
          <div className="col-lg-4 my-auto">
            <div className="text-center" style={{ paddingBottom: "50px" }}>
              <img alt="Eduprime Logo" style={{ width: "50%", height: "auto" }} src={eduprimeLogo} />
            </div>
            <div className="card" style={{ backgroundColor: "rgba(237,240,243,1)", border: "none" }}>
              <div className="card-body">
                <h4 className="text-center">Admin Login</h4>
                <form onSubmit={this.props.handleSubmit(this.submitLogin)}>
                  <div className="row">
                    <div className="col-lg-12">
                      <Field name="username" component={this.renderInput} label="Username" type="text" placeholder="Username" />
                      <Field name="password" component={this.renderInput} label="Password" type="password" placeholder="Password" />

                      {this.renderAlert()}
                    </div>
                    <div className="col-lg-12" style={{ paddingTop: "10px" }}>
                      <button className="btn btn-primary" style={{ width: "100%" }}>
                        Login
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validate = (formValues) => {
  const errors = {};
  if (!formValues.username) {
    errors.username = "Anda harus memasukkan username";
  }
  if (!formValues.password) {
    errors.password = "Anda harus memasukkan password";
  }
  return errors;
};

const mapStateToProps = (state) => {
  return {
    account: state.account,
    fetchError: state.error,
  };
};

const formWrapped = reduxForm({
  form: "login",
  validate,
})(Login);

export default connect(mapStateToProps, { signIn, cekCookies })(formWrapped);
